import React, { useRef, useState } from "react";
import OmniFormGroup from "../../../Shared/OmniFormGroup/OmniFormGroup";
import ValidationErrors from "../../../Settings/ValidationErrors";

import { Formik } from "formik";
import * as Yup from "yup";

const validationSchema = (_) => {
  const msg = _.ClientForms.ContactClientCare.ValidationMessages;
  return Yup.object({
    reason: Yup.string().required(msg.reason),
    email: Yup.string()
      .email(msg.emailFormat)
      .required(msg.email)
      .max(80, msg.messageMaxLength80),
    description: Yup.string().required(msg.description),
  });
};

export const Form = ({ _, SystemDetail }) => {
  const url = `${window.document.location.origin}/client-forms/contact-client-care-completed`;

  const [returnUrl, setreturnUrl] = useState(url);
  const fields = _.ClientForms.ContactClientCare.Fields;

  const formEl = useRef(null);

  const objectToQuerystring = (obj) => {
    return Object.keys(obj).reduce(function (str, key, i) {
      var delimiter, val;
      delimiter = i === 0 ? "?" : "&";
      key = encodeURIComponent(key);
      val = encodeURIComponent(obj[key]);
      return [str, delimiter, key, "=", val].join("");
    }, "");
  };

  return (
    <Formik
      initialValues={{
        reason: "",
        description: "",
        ...SystemDetail,
      }}
      onSubmit={(values) => {
        const queryString = objectToQuerystring(values);
        setreturnUrl(`${url}${queryString}`);
        formEl.current.submit();
      }}
      validationSchema={validationSchema(_)}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        isValid,
      }) => (
        <>
          <form
            ref={formEl}
            action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
            method="POST"
            target="_top"
            // rel="noopener"
          >
            <input type="hidden" name="orgid" value="00D70000000Mc9e" />
            <input type="hidden" name="retURL" value={returnUrl} />

            <div className="flex-wrap ml-3 contact-client-care">
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xKkh"
                  Name="00N4u000003xKkh"
                  Type="select"
                  LabelName={
                    <>
                      {fields.reason} <span className="required"></span>
                    </>
                  }
                  Value={values.reason}
                  onChange={(e) => {
                    var index = e.nativeEvent.target.selectedIndex;
                    var selectedText = e.nativeEvent.target[index].text;

                    setFieldValue("reasonText", selectedText);
                    setFieldValue("reason", e.target.value);
                  }}
                >
                  <option value="">--None--</option>
                  {_.ClientForms.ContactClientCare.Reasons.map((reason, i) => (
                    <option value={reason} key={i}>
                      {reason}
                    </option>
                  ))}
                </OmniFormGroup>
                <ValidationErrors
                  touched={touched.reason}
                  message={errors.reason}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="email"
                  Name="email"
                  Type="email"
                  Placeholder={fields.email}
                  LabelName={
                    <>
                      {fields.email} <span className="required"></span>
                    </>
                  }
                  Value={values.email}
                  onChange={handleChange}
                  maxLength={80}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.email}
                  message={errors.email}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="description"
                  Name="description"
                  Type="textarea"
                  LabelName={
                    <>
                      {fields.description} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.description}
                  Value={values.description}
                  onChange={handleChange}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.addressLine1}
                  message={errors.addressLine1}
                ></ValidationErrors>
              </div>
            </div>
            <div className="d-flex mt-3 ml-3">
              <button
                className="styled-button"
                type="submit"
                disabled={isSubmitting || !isValid}
                onClick={handleSubmit}
              >
                {_.ClientForms.ContactClientCare.SubmitForm}
              </button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};
